import React from 'react';
import { Dropdown, Nav } from 'react-bootstrap';

const ActionItem = ({
  name,
  count,
  tags,
  id,
  handleEdit,
  handleItemClick,
  handleDelete,
  handleExport,
  className,
  type,
}) => (
  <Nav.Item as="li" title={name}>
    <Nav.Link as="a" className={className} onClick={() => handleItemClick(name, id, tags)}>
      <span className="nav-name">{name}</span>
      <span>
        <span className="nav-item-count">{count}</span>
        <Dropdown>
          <Dropdown.Toggle variant="link" id={`dropdown-${name}`}>
            <i className="fas fa-ellipsis-v" />
          </Dropdown.Toggle>
          <Dropdown.Menu align="right">
            <Dropdown.Item onClick={handleEdit}>Edit Contact List</Dropdown.Item>
            <Dropdown.Item onClick={handleDelete}>Delete {type}</Dropdown.Item>
            <Dropdown.Item onClick={handleExport}>Export as CSV</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </span>
    </Nav.Link>
  </Nav.Item>
);

export default ActionItem;